import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default function (params) {
  const { data, exec, isLoading } = useRequest({
    url: '',
    name: 'GET_ADDITIVES',
  });
  useEffect(() => {
    if (params && JSON.stringify(params) !== '{}') {
      let url = `/api/additives`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?'
        } else {
          url += '&'
        };
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [data || {}, exec, isLoading];
}